import { render, staticRenderFns } from "./advancedSimpleUploader.vue?vue&type=template&id=5842d709&scoped=true"
import script from "./advancedSimpleUploader.vue?vue&type=script&lang=js"
export * from "./advancedSimpleUploader.vue?vue&type=script&lang=js"
import style0 from "./advancedSimpleUploader.vue?vue&type=style&index=0&id=5842d709&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5842d709",
  null
  
)

/* custom blocks */
import block0 from "./advancedSimpleUploader.vue?vue&type=custom&index=0&blockType=advanced-simple-uploader&%3AbeforeFileList=beforeRequirementFileDetail&%3AmaxNum=1&isSource=https%3A%2F%2Fgateway.yingxiong.com%2Ffile-api%2Fapi%2Ffile%2FfileChunkUpload&source=coop&ref=uploader&%40onSuccess=(file%2C%20fileList)%20%3D%3E%20handleSuccess(file%2C%20fileList%2C%20'requirementFileId')&%40onRemove=handleRemove(%24event%2C'requirementFileId')&%40onDelete=handleRemove(%24event%2C'requirementFileId')&style=min-width%3A660px%3B%20width%3A25vw"
if (typeof block0 === 'function') block0(component)

export default component.exports